import { Card, Grid } from "@mui/material";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import WalletTopup from "Pages/Dashboard/NewUser/WalletTopup";

const Preference = () => {
  return (
    <DashboardLayout>
      <Card>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {/* <BrokerPreference /> */}
          </Grid>
          <Grid item xs={12}>
            <WalletTopup />
          </Grid>
        </Grid>
      </Card>
    </DashboardLayout>
  );
};

export default Preference;
